Fancybox.bind(
  'a[href$=".jpg"]:not([download]), a[href$=".jpeg"]:not([download]), a[href$=".png"]:not([download]), a[href$=".webm"]:not([download])',
  {
    groupAll: true,
    contentClick: "toggleZoom", // Optional: Click to zoom
    
    Toolbar: {
      display: {
        left: ["infobar"],
        middle: [
          "zoomIn",
          "zoomOut"
        ],
        right: ["slideshow", "download", "thumbs", "close"],
      },
    },
    
    Images: {
      download: true  // Enables the download button
    },
    
    caption: function (fancybox, slide) {
      let caption = "";
    
      // Find the image element inside the clicked link
      let img = slide.triggerEl.querySelector("img");
      if (img) {
        // Check if the image is inside a <figure> and has a <figcaption>
        let figure = img.closest("figure");
        if (figure) {
          let figcaption = figure.querySelector("figcaption");
          if (figcaption) {
            caption = figcaption.innerHTML.trim(); // Use figure caption
          }
        }
    
        // Fallback: Use alt text if no figcaption is found
        if (!caption) {
          caption = img.alt || img.title || "Image";
        }
      }
    
      return caption;
    }
  }
);

Fancybox.defaults.l10n = {
    CLOSE: "Schließen",
    NEXT: "weiter",
    PREV: "zurück",
    MODAL: "Sie können diesen Inhalt mit der ESC-Taste schließen",
    ERROR: "Fehler. Bitte versuch es später noch einmal.",
    IMAGE_ERROR: "Bild nicht gefunden",
    ELEMENT_NOT_FOUND: "HTML Fehler: Nicht gefunden",
    AJAX_NOT_FOUND: "AJAX Fehler: Nicht gefunden",
    AJAX_FORBIDDEN: "AJAX Fehler: kein Zugriff",
    IFRAME_ERROR: "Fehler beim Laden der Seite",
    TOGGLE_ZOOM: "Umschalten des Zooms",
    TOGGLE_THUMBS: "Umschalten des Vorschaubild Modus",
    TOGGLE_SLIDESHOW: "Umschalten des Diashow Modus",
    TOGGLE_FULLSCREEN: "Umschalten des Vollbildmodus",
    DOWNLOAD: "Download",
    ZOOMIN: "vergrößerm",
    ZOOMOUT: "verkleinern"
}